import { ActivatedRoute } from '@angular/router';

export const GetOverviewId = (route: ActivatedRoute): string => {
    // Subproperties can be undefined in unit tests
    if (route?.snapshot?.data?.isOverview) {
        return (
            '/' +
            route.snapshot.pathFromRoot
                .flatMap(routeSnapshot => routeSnapshot.url)
                .map(urlSegment => urlSegment.toString())
                .filter(str => str)
                .join('/')
        );
    }
    if (!route.parent) {
        return '';
    }
    return GetOverviewId(route.parent);
};

/**
 * HFBD-7a: the column state's key for the level below the top one. `ColumnManagementService` is keyed by an
 * opaque string over a flat `Record<string, string[]>`, so a second level costs one extra `configure()` call
 * under a compound key rather than a reworked service — and the two levels persist independently.
 */
export const GetChildOverviewId = (overviewId: string): string => `${overviewId}:document`;
